import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationTE from './locales/te/translation.json';

const resources = {
  en_IN: { translation: translationEN },
  te_IN: { translation: translationTE }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en_IN',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage',
      caches: ['localStorage']
    }
  }).then(() => {
    console.log('i18n initialized');
  });

// Set initial language
const savedLanguage = localStorage.getItem('selectedLanguage');
if (savedLanguage) {
  i18n.changeLanguage(savedLanguage);
}

export default i18n;
